import React from 'react';

if (typeof document !== 'undefined' && !document.getElementById('sit-timepicker-css')) {
  const el = document.createElement('style');
  el.id = 'sit-timepicker-css';
  el.textContent = `
.sit-tp { display: inline-flex; flex-direction: column; gap: 6px; position: relative; width: fit-content; }
.sit-tp__label { font-size: var(--text-sm); font-weight: var(--weight-semibold); color: var(--text-body); display: inline-flex; align-items: center; gap: 4px; }
.sit-tp__req { color: var(--red-500); }
.sit-tp__wrap {
  display: inline-flex; align-items: center; gap: 8px; width: fit-content; height: var(--control-h-md);
  padding: 0 6px 0 12px; background: var(--slate-0); border: 1px solid var(--border-default); border-radius: var(--radius-md);
  transition: border-color var(--dur-base) var(--ease-out), box-shadow var(--dur-base) var(--ease-out);
}
.sit-tp--sm .sit-tp__wrap { height: var(--control-h-sm); }
.sit-tp--sm .sit-tp__input { font-size: var(--text-sm); }
.sit-tp__wrap:hover { border-color: var(--border-strong); }
.sit-tp__wrap--open, .sit-tp__wrap--focus { border-color: var(--border-brand); box-shadow: var(--shadow-focus); }
.sit-tp--invalid .sit-tp__wrap { border-color: var(--red-500); }
.sit-tp__wrap--disabled { background: var(--surface-sunken); cursor: not-allowed; }
.sit-tp__ico { color: var(--text-subtle); flex: 0 0 auto; display: inline-flex; cursor: pointer; }
.sit-tp__ico svg { width: 16px; height: 16px; }
.sit-tp__input {
  flex: 0 0 auto; border: none; background: none; outline: none; padding: 0;
  font-family: var(--font-body); font-size: var(--text-md); color: var(--text-strong); font-variant-numeric: tabular-nums;
  cursor: pointer;
}
.sit-tp__input::placeholder { color: var(--text-subtle); font-variant-numeric: initial; }
.sit-tp__input[disabled] { color: var(--text-muted); cursor: not-allowed; }
.sit-tp__stepper { display: flex; flex-direction: column; flex: 0 0 auto; }
.sit-tp__step {
  width: 20px; height: 15px; display: inline-flex; align-items: center; justify-content: center;
  border: none; background: none; color: var(--text-subtle); cursor: pointer; padding: 0; border-radius: 4px;
}
.sit-tp__step:hover { background: var(--surface-hover); color: var(--text-strong); }
.sit-tp__step svg { width: 11px; height: 11px; }
.sit-tp__clear {
  flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center;
  width: 18px; height: 18px; border: none; background: none; color: var(--text-subtle);
  border-radius: var(--radius-pill); cursor: pointer; padding: 0;
}
.sit-tp__clear:hover { background: var(--surface-hover); color: var(--text-body); }
.sit-tp__clear svg { width: 12px; height: 12px; }
.sit-tp__msg { font-size: var(--text-xs); color: var(--text-muted); }
.sit-tp__msg--error { color: var(--red-600); }

.sit-tp__pop {
  position: absolute; top: calc(100% + 6px); z-index: var(--z-overlay); left: 0;
  background: var(--surface-card); border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg); box-shadow: var(--shadow-lg);
  animation: sit-tp-in var(--dur-fast) var(--ease-out); overflow: hidden;
}
.sit-tp__pop--right { left: auto; right: 0; }
@keyframes sit-tp-in { from { opacity: 0; transform: translateY(-4px); } to { opacity: 1; transform: none; } }
.sit-tp__now {
  width: 100%; text-align: center; padding: 9px 14px; border: none; border-bottom: 1px solid var(--border-subtle);
  background: var(--slate-25); font-family: var(--font-body); font-size: var(--text-xs); font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-caps); text-transform: uppercase; color: var(--blue-700); cursor: pointer;
}
.sit-tp__now:hover { background: var(--surface-hover); }
.sit-tp__cols { display: flex; align-items: stretch; padding: 8px; }
.sit-tp__col {
  width: 56px; max-height: 216px; overflow-y: auto; padding: 2px; display: flex; flex-direction: column; gap: 2px;
  scrollbar-width: thin; scrollbar-color: var(--slate-300) transparent;
}
.sit-tp__col::-webkit-scrollbar { width: 6px; }
.sit-tp__col::-webkit-scrollbar-thumb { background: var(--slate-300); border-radius: var(--radius-pill); }
.sit-tp__sep { align-self: center; font-weight: var(--weight-bold); color: var(--text-subtle); padding: 0 2px; }
.sit-tp__opt {
  flex: 0 0 auto; height: 32px; border: none; background: none; border-radius: var(--radius-md);
  font-family: var(--font-body); font-size: var(--text-sm); font-weight: var(--weight-medium);
  color: var(--text-body); cursor: pointer; font-variant-numeric: tabular-nums;
}
.sit-tp__opt:hover { background: var(--surface-hover); color: var(--text-strong); }
.sit-tp__opt--active, .sit-tp__opt--active:hover { background: var(--action-primary); color: var(--text-on-brand); font-weight: var(--weight-semibold); }
.sit-tp__opt:disabled { opacity: 0.3; cursor: not-allowed; }
.sit-tp__opt:disabled:hover { background: none; }
.sit-tp__ampm { display: flex; flex-direction: column; gap: 4px; padding: 2px 4px 2px 6px; align-self: center; }
.sit-tp__footer { display: flex; justify-content: flex-end; padding: 8px; border-top: 1px solid var(--border-subtle); }
.sit-tp__done {
  min-width: 72px; height: 32px; padding: 0 14px; border: none; border-radius: var(--radius-md);
  background: var(--action-primary); color: var(--text-on-brand); font-family: var(--font-body);
  font-size: var(--text-sm); font-weight: var(--weight-semibold); cursor: pointer;
}
.sit-tp__done:hover { background: var(--action-primary-hover, var(--blue-700)); }
`;
  document.head.appendChild(el);
}

/* ---------------- helpers ---------------- */
const pad2 = n => String(n).padStart(2, '0');
const minutesOf = d => (d ? d.getHours() * 60 + d.getMinutes() : null);

function formatTime(d, use12h) {
  if (!d) return '';
  const H = d.getHours(),
    M = d.getMinutes();
  if (!use12h) return `${pad2(H)}:${pad2(M)}`;
  const h12 = H % 12 === 0 ? 12 : H % 12;
  return `${pad2(h12)}:${pad2(M)} ${H < 12 ? 'AM' : 'PM'}`;
}

/** Accepts "9", "930", "9:30", "14:30", "2:30pm", "2pm" ... returns a Date (today's date, given time) or null. */
function parseTimeInput(str, use12h) {
  if (!str) return null;
  const s = str.trim().toLowerCase();
  const m = s.match(/^(\d{1,2})(?::?(\d{2}))?\s*(am|pm)?$/);
  if (!m) return null;
  let h = parseInt(m[1], 10);
  const min = m[2] ? parseInt(m[2], 10) : 0;
  const ap = m[3];
  if (min > 59) return null;
  if (ap) {
    if (h < 1 || h > 12) return null;
    h = (h % 12) + (ap === 'pm' ? 12 : 0);
  } else if (use12h) {
    if (h < 1 || h > 12) return null;
  } else if (h > 23) return null;
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, min, 0, 0);
}

function withTime(base, h, m) {
  const b = base || new Date();
  return new Date(b.getFullYear(), b.getMonth(), b.getDate(), h, m, 0, 0);
}

function clampToBounds(d, min, max) {
  if (!d) return d;
  const v = minutesOf(d);
  if (min && v < minutesOf(min)) return new Date(min.getTime());
  if (max && v > minutesOf(max)) return new Date(max.getTime());
  return d;
}

/* ---------------- TimePicker ---------------- */
export function TimePicker({
  label,
  value,
  onChange,
  placeholder = 'Time',
  min,
  max,
  minuteStep = 5,
  use12h = false,
  align = 'left',
  size = 'md',
  required = false,
  disabled = false,
  clearable = true,
  showConfirm = false,
  hint,
  error,
  id,
  className = ''
}) {
  const [open, setOpen] = React.useState(false);
  const [focused, setFocused] = React.useState(false);
  const [text, setText] = React.useState(formatTime(value, use12h));
  const ref = React.useRef(null);
  const hourRef = React.useRef(null);
  const minRef = React.useRef(null);

  React.useEffect(() => {
    if (!focused) setText(formatTime(value, use12h));
  }, [value, use12h, focused]); // eslint-disable-line

  React.useEffect(() => {
    if (!open) return;
    const h = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
        setFocused(false);
      }
    };
    const esc = e => {
      if (e.key === 'Escape') {
        setOpen(false);
        setFocused(false);
      }
    };
    document.addEventListener('mousedown', h);
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('mousedown', h);
      document.removeEventListener('keydown', esc);
    };
  }, [open]);

  React.useLayoutEffect(() => {
    if (!open) return;
    const scroll = () => {
      [hourRef, minRef].forEach(r => {
        const elh = r.current && r.current.querySelector('.sit-tp__opt--active');
        if (elh && r.current) r.current.scrollTop = elh.offsetTop - r.current.clientHeight / 2 + elh.clientHeight / 2;
      });
    };
    scroll();
    const id2 = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(id2);
  }, [open]); // eslint-disable-line

  const commit = d => {
    const next = clampToBounds(d, min, max);
    setText(formatTime(next, use12h));
    onChange && onChange(next);
  };
  const bump = mins => {
    const base = value || withTime(null, 9, 0);
    const total = (((base.getHours() * 60 + base.getMinutes() + mins) % 1440) + 1440) % 1440;
    commit(withTime(base, Math.floor(total / 60), total % 60));
  };

  const commitText = () => {
    const parsed = parseTimeInput(text, use12h);
    if (parsed) commit(parsed);
    else setText(formatTime(value, use12h));
  };

  const hours = use12h ? Array.from({ length: 12 }, (_, i) => i + 1) : Array.from({ length: 24 }, (_, i) => i);
  const minutes = Array.from({ length: Math.ceil(60 / minuteStep) }, (_, i) => i * minuteStep);
  const H = value ? value.getHours() : null;
  const M = value ? value.getMinutes() : null;
  const activeHour = H == null ? null : use12h ? (H % 12 === 0 ? 12 : H % 12) : H;
  const isPM = H != null && H >= 12;
  const to24 = (h12, pm) => (h12 % 12) + (pm ? 12 : 0);

  const minM = min ? minutesOf(min) : null;
  const maxM = max ? minutesOf(max) : null;
  const hourDisabled = h => {
    const h24 = use12h ? to24(h, isPM) : h;
    if (minM != null && (h24 + 1) * 60 - 1 < minM) return true;
    if (maxM != null && h24 * 60 > maxM) return true;
    return false;
  };
  const minDisabled = m => {
    if (H == null) return false;
    const t = H * 60 + m;
    if (minM != null && t < minM) return true;
    if (maxM != null && t > maxM) return true;
    return false;
  };

  const setHour = h => commit(withTime(value, use12h ? to24(h, isPM) : h, M == null ? 0 : M));
  const setMin = m => commit(withTime(value, H == null ? (use12h ? to24(1, false) : 0) : H, m));
  const setAmPm = pm => commit(withTime(value, use12h ? to24(activeHour || 12, pm) : H, M == null ? 0 : M));

  const inputId = id || (label ? `tp-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);
  const wrapCls = [
    'sit-tp__wrap',
    open ? 'sit-tp__wrap--open' : focused ? 'sit-tp__wrap--focus' : '',
    disabled ? 'sit-tp__wrap--disabled' : ''
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div
      className={['sit-tp', size === 'sm' ? 'sit-tp--sm' : '', error ? 'sit-tp--invalid' : '', className]
        .filter(Boolean)
        .join(' ')}
      ref={ref}
    >
      {label ? (
        <label className="sit-tp__label" htmlFor={inputId}>
          {label}
          {required ? <span className="sit-tp__req">*</span> : null}
        </label>
      ) : null}
      <div className={wrapCls}>
        <span className="sit-tp__ico" onClick={() => !disabled && setOpen(o => !o)}>
          <ClockIcon />
        </span>
        <input
          id={inputId}
          className="sit-tp__input"
          size={use12h ? 8 : 5}
          value={text}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={() => {
            setFocused(true);
            setOpen(true);
          }}
          onChange={e => setText(e.target.value)}
          onBlur={commitText}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              commitText();
              setOpen(false);
              e.currentTarget.blur();
            }
          }}
        />
        {!disabled ? (
          <span className="sit-tp__stepper">
            <button
              type="button"
              className="sit-tp__step"
              tabIndex={-1}
              aria-label="Increase"
              onClick={() => bump(minuteStep)}
            >
              <ChevUp />
            </button>
            <button
              type="button"
              className="sit-tp__step"
              tabIndex={-1}
              aria-label="Decrease"
              onClick={() => bump(-minuteStep)}
            >
              <ChevDown />
            </button>
          </span>
        ) : null}
        {clearable && value && !disabled ? (
          <span
            className="sit-tp__clear"
            role="button"
            aria-label="Clear"
            onClick={e => {
              e.stopPropagation();
              commit(null);
              setText('');
            }}
          >
            <XIcon />
          </span>
        ) : null}
      </div>

      {open && !disabled ? (
        <div className={['sit-tp__pop', `sit-tp__pop--${align}`].join(' ')} role="dialog">
          <button
            type="button"
            className="sit-tp__now"
            onClick={() => {
              const n = new Date();
              commit(withTime(n, n.getHours(), (Math.round(n.getMinutes() / minuteStep) * minuteStep) % 60));
            }}
          >
            Now
          </button>
          <div className="sit-tp__cols">
            <div className="sit-tp__col" ref={hourRef}>
              {hours.map(h => (
                <button
                  type="button"
                  key={h}
                  disabled={hourDisabled(h)}
                  className={['sit-tp__opt', h === activeHour ? 'sit-tp__opt--active' : ''].join(' ')}
                  onClick={() => setHour(h)}
                >
                  {pad2(h)}
                </button>
              ))}
            </div>
            <span className="sit-tp__sep">:</span>
            <div className="sit-tp__col" ref={minRef}>
              {minutes.map(m => (
                <button
                  type="button"
                  key={m}
                  disabled={minDisabled(m)}
                  className={['sit-tp__opt', m === M ? 'sit-tp__opt--active' : ''].join(' ')}
                  onClick={() => setMin(m)}
                >
                  {pad2(m)}
                </button>
              ))}
            </div>
            {use12h ? (
              <div className="sit-tp__ampm">
                <button
                  type="button"
                  className={['sit-tp__opt', H != null && !isPM ? 'sit-tp__opt--active' : ''].join(' ')}
                  onClick={() => setAmPm(false)}
                >
                  AM
                </button>
                <button
                  type="button"
                  className={['sit-tp__opt', H != null && isPM ? 'sit-tp__opt--active' : ''].join(' ')}
                  onClick={() => setAmPm(true)}
                >
                  PM
                </button>
              </div>
            ) : null}
          </div>
          {showConfirm ? (
            <div className="sit-tp__footer">
              <button
                type="button"
                className="sit-tp__done"
                onClick={() => {
                  setOpen(false);
                  setFocused(false);
                }}
              >
                Done
              </button>
            </div>
          ) : null}
        </div>
      ) : null}

      {error ? (
        <span className="sit-tp__msg sit-tp__msg--error">{error}</span>
      ) : hint ? (
        <span className="sit-tp__msg">{hint}</span>
      ) : null}
    </div>
  );
}
TimePicker.displayName = 'TimePicker';

/** Formats minutes-difference between two time-of-day Dates as "1h 30m". Returns '' if either is missing or end <= start. */
export function FormatDuration(start, end) {
  if (!start || !end) return '';
  let mins = minutesOf(end) - minutesOf(start);
  if (mins <= 0) return '';
  const h = Math.floor(mins / 60),
    m = mins % 60;
  return [h ? `${h}h` : '', m ? `${m}m` : ''].filter(Boolean).join(' ');
}

/* ---------------- icons ---------------- */
function ClockIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3.5 2" />
    </svg>
  );
}
function XIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      aria-hidden="true"
    >
      <path d="M5 5l14 14M19 5L5 19" />
    </svg>
  );
}
function ChevUp() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M6 15l6-6 6 6" />
    </svg>
  );
}
function ChevDown() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}
